import React from 'react';

const About = ({ t }) => {
  return (
    <section className="about">
      <div className="about__illustrations">
        <img src="/images/about-me.png" alt="" className="about__image" />
      </div>
      <div className="about__text">
        {t.description.map((text, index) => (
          <p key={index} className="about__description">{text}</p>
        ))}
      </div>
    </section>
  );
};

export default About;
